import axios, { AxiosInstance, AxiosResponse } from 'axios';
import store from '@/store/store';
import { AuthorizationTokens } from '@/state/auth/authTypes';
import { updateTokens } from '@/state/auth/authSlice';
import { logoutMember } from '@/state/member/useMember';
import axiosAuthRefresh from 'axios-auth-refresh';

const createAuthRefreshInterceptor = (axiosAuthRefresh as any).default ?? axiosAuthRefresh;

const refreshTokenInterceptor = (axiosInstance: AxiosInstance) => {
    const refreshAuthLogic = (failedRequest: any) =>
        axios(`${import.meta.env.REACT_APP_URL}/auth/refreshToken`, {
            method: 'GET',
            headers: { authorization: `Bearer ${store.getState()?.auth?.tokens?.refreshToken}` },
        })
            .then((tokenRefreshResponse: AxiosResponse<{ authorization: AuthorizationTokens }>) => {
                store.dispatch(updateTokens(tokenRefreshResponse.data.authorization));
                failedRequest.response.config.headers['Authorization'] =
                    `Bearer ${tokenRefreshResponse.data.authorization.accessToken}`;
                return Promise.resolve();
            })
            .catch((error) => {
                console.error(error);
                logoutMember(false);
                return Promise.reject(error);
            });

    return createAuthRefreshInterceptor(axiosInstance, refreshAuthLogic, { statusCodes: [498] });
};

export default refreshTokenInterceptor;
